import { Flex, DrawerOverlay, Box } from '@chakra-ui/react';

import { BottomDrawer, DrawerBody, DrawerContent } from 'uiToolkitV1/BottomDrawer';
import { Button } from 'uiToolkitV1/Button';

const Footer = ({ showFooterCloseButton = false, onClose, onSave, isSaveDisabled = false }) => (
  <Flex
    py={3}
    px={4}
    bottom={0}
    justifyContent="space-between"
    alignItems="center"
    bg="surface.F5F7F9"
    borderTop="1px solid"
    borderColor="border.CFD7DF"
    borderBottomRadius="8px"
  >
    {!showFooterCloseButton && (
      <>
        <Button variant="outlined" onClick={onClose}>
          {showFooterCloseButton ? 'Close' : 'Cancel'}
        </Button>
        <Button onClick={onSave} disabled={isSaveDisabled}>
          Save
        </Button>
      </>
    )}
    {showFooterCloseButton && (
      <>
        <Box />
        <Button onClick={onClose}>Close</Button>
      </>
    )}
  </Flex>
);

const ReviewCreationSidepanel = ({
  isOpen = true,
  onClose,
  showFooterCloseButton = false,
  onSave,
  children,
  isSaveDisabled = false,
}) => (
  <BottomDrawer isOpen={isOpen} onClose={onClose} autoFocus={false}>
    <DrawerOverlay />

    <DrawerContent width="700px">
      <DrawerBody>
        <Flex borderRadius="8px" h="calc(100% - 8px)" m="1" flexDir="column" border="4px solid #E7EBEF" bg="white">
          <Box borderRadius="8px" borderColor="" overflow="auto" flex={1} px={2}>
            {children}
          </Box>

          <Footer
            showFooterCloseButton={showFooterCloseButton}
            onClose={onClose}
            onSave={onSave}
            isSaveDisabled={isSaveDisabled}
          />
        </Flex>
      </DrawerBody>
    </DrawerContent>
  </BottomDrawer>
);

export { ReviewCreationSidepanel };
